import { render, staticRenderFns } from "./-Cards.vue?vue&type=template&id=2398d6db&scoped=true&"
import script from "./-Cards.vue?vue&type=script&lang=js&"
export * from "./-Cards.vue?vue&type=script&lang=js&"
import style0 from "./-Cards.vue?vue&type=style&index=0&id=2398d6db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398d6db",
  null
  
)

export default component.exports